
export default {
  getFileDataUrl (path) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader()
      reader.readAsDataURL(path)
      reader.onload = () => {
        let url = reader.result
        resolve(url)
      }
    })
  },
  getImgBase64 (fileDataUrl, w, h) {
    return new Promise((resolve, reject) => {
      var img = new Image()
      img.src = fileDataUrl
      img.onload = function () {
        let proportion = this.width / this.height
        let canvasW = w
        let canvasH = h
        if (!w && !h) {
          // 按原始比例
          if (!w) w = this.width
          if (!h) h = this.height
        } else if (w && !h) {
          h = w / proportion
        } else if (!w && h) {
          w = h * proportion
        }

        var quality = 0.95 // 默认图片质量为0.7

        // 生成canvas
        var canvas = document.createElement('canvas')
        var ctx = canvas.getContext('2d')

        // 创建属性节点
        canvas.setAttribute('width', canvasW)
        canvas.setAttribute('height', canvasH)

        ctx.drawImage(this, 0, 0, w, h)
        // quality值越小，所绘制出的图像越模糊
        var base64 = canvas.toDataURL('image/jpeg', quality)
        // 回调函数返回base64的值
        resolve(base64)
      }
    })
  }

}
